import baseTheme from '../baseTheme';
var THUMB_SIZE = 28;
var MuiSwitch = {
    root: {
        width: 54 + parseInt(baseTheme.spacing(1)) * 2,
        height: 28 + parseInt(baseTheme.spacing(0.25)) * 2,
        padding: baseTheme.spacing(0.25, 1),
        '&:hover .MuiSwitch-track': {
            boxShadow: "0 0 0 4px " + baseTheme.palette.primary.light,
        },
    },
    colorSecondary: {
        '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: baseTheme.palette.secondary.main,
            borderColor: baseTheme.palette.secondary.main,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            backgroundColor: baseTheme.palette.grey[200],
        },
        '&.Mui-disabled.Mui-checked + .MuiSwitch-track': {
            backgroundColor: baseTheme.palette.grey[400],
            borderColor: baseTheme.palette.grey[400],
        },
        '&&.Mui-checked:hover': {
            backgroundColor: 'transparent',
        },
    },
    switchBase: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&.Mui-focusVisible + .MuiSwitch-track': {
            boxShadow: "0 0 0 4px " + baseTheme.palette.primary.light,
        },
        /** the pseudoelements form the X or the checkmark */
        '&::before': {
            content: '""',
            position: 'absolute',
            right: '-6px',
            top: '16px',
            width: '16px',
            height: '1px',
            transform: 'rotate(45deg)',
            borderBottom: "1px solid " + baseTheme.palette.text.primary,
            transition: baseTheme.transitions.create([
                'right',
                'top',
                'width',
                'border-color',
            ]),
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            right: '-6px',
            top: '16px',
            width: '16px',
            height: '1px',
            transform: 'rotate(135deg)',
            borderBottom: "1px solid " + baseTheme.palette.text.primary,
            transition: baseTheme.transitions.create([
                'right',
                'top',
                'width',
                'border-color',
            ]),
        },
        '&.Mui-disabled': {
            '&::before': {
                borderColor: baseTheme.palette.grey[800],
            },
            '&::after': {
                borderColor: baseTheme.palette.grey[800],
            },
            '& .MuiSwitch-thumb': {
                borderColor: baseTheme.palette.grey[400],
                boxShadow: 'none',
                backgroundColor: baseTheme.palette.grey[200],
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: baseTheme.palette.grey[200],
                borderColor: baseTheme.palette.grey[400],
                boxShadow: 'none',
            },
        },
        '&.Mui-checked': {
            left: THUMB_SIZE - 2 + "px",
            transform: 'translate(0)',
            '&::before': {
                right: '52px',
                width: '6px',
                top: '19px',
                borderColor: baseTheme.palette.common.white,
            },
            '&::after': {
                right: '40px',
                width: '15px',
                borderColor: baseTheme.palette.common.white,
            },
            '& .MuiSwitch-thumb': {
                borderColor: baseTheme.palette.grey[400],
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: baseTheme.palette.grey[400],
            },
        },
    },
    thumb: {
        width: THUMB_SIZE,
        height: THUMB_SIZE,
        border: "2px solid " + baseTheme.palette.grey[300],
        borderRadius: THUMB_SIZE,
        backgroundColor: baseTheme.palette.common.white,
        zIndex: 2,
        pointerEvents: 'none',
        position: 'relative',
        top: -7,
        left: -1,
    },
    track: {
        height: 24,
        marginTop: 'auto',
        marginBottom: 'auto',
        opacity: 1,
        flexShrink: 0,
        borderRadius: THUMB_SIZE,
        backgroundColor: baseTheme.palette.grey[100],
        border: "2px solid " + baseTheme.palette.grey[300],
        transition: baseTheme.transitions.create([
            'background-color',
            'border-color',
            'box-shadow',
        ]),
    },
};
export default MuiSwitch;
//# sourceMappingURL=MuiSwitch.js.map